import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DatazoomService } from '../../../analytics/datazoom/service/datazoom.service';
import { EventName } from '../../../analytics/newrelic/enums/EventName';
import { NewrelicService } from '../../../analytics/newrelic/service/newrelic.service';
import { FireboltService } from '../firebolt.service';

@Injectable()
export class ExitConfirmationService {
  private showPopup = new BehaviorSubject(false);
  private isOpen = false;

  get isExitConfirmationOpen(): boolean {
    return this.isOpen;
  }

  constructor(private newrelic: NewrelicService, private datazoom: DatazoomService, private fireboltService: FireboltService) {}

  showExitConfirmation(): void {
    this.showPopup.next(true);
    this.isOpen = true;
  }

  closeExitConfirmation(): void {
    this.isOpen = false;
    this.showPopup.next(false);
  }

  listenExitConfirmation(): Observable<boolean> {
    return this.showPopup.asObservable();
  }

  closeApp() {
    this.datazoom.stop();
    this.newrelic.sendNewrelicEvent(EventName.APP_BACKGROUND);
    this.datazoom.reportBackground();
    this.fireboltService.exit();
    // if (navigator.userAgent.includes('Tizen')) {
    //   tizen?.application.getCurrentApplication().exit();
    // } else {
    //   window.close();
    // }
  }
}
